import * as React from "react";
import {Transition} from 'react-transition-group'

interface FadingElementProps {
  in: boolean
  children?: any
}

const FadingElement = (props: FadingElementProps) => (
  <Transition in={props.in} timeout={150}>
    {(state: any) => (
      <div style={{...DefaultStyle,...TransitionStyles[state]}}>
        {...props.children}
      </div>
    )}
  </Transition>
);

/** STYLES */

const DefaultStyle = {
  transition: `opacity .15s linear`,
  opacity: 0,
  display: 'none'
};

const TransitionStyles: React.CSSProperties = {
  entering: {
    opacity: 0,
    display: 'none'
  },
  entered: {
    opacity: 1,
    display: 'block'
  }
};

export default FadingElement


// WEBPACK FOOTER //
// ./src/layouts/animation/fading-element/fading-element.tsx